package net.frozenbit.games.soundgame.ui

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.itemsIndexed
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.drawWithCache
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import net.frozenbit.games.soundgame.components.SoundNumberIndicator
import net.frozenbit.games.soundgame.theme.Typography
import net.frozenbit.games.soundgame.theme.onSecondaryContainerLight
import net.frozenbit.games.soundgame.theme.primaryContainerLight
import net.frozenbit.games.soundgame.theme.secondaryContainerLight
import net.frozenbit.games.soundgame.theme.surfaceDimLight
import net.frozenbit.games.soundgame.ui.utils.animateTimeProgress
import net.frozenbit.games.soundgame.utils.Timeout
import net.frozenbit.games.soundgame.viewmodels.ControllerViewModel

@Composable
fun ControllerSoundSelectionScreen(
    soundOptions: List<ControllerViewModel.ControllerUiState.SoundSelection.SoundOption>,
    lockInTimeout: Timeout?,
    onSoundSelected: (Int) -> Unit,
) {
    val lockInProgress = animateTimeProgress(lockInTimeout?.start, lockInTimeout?.end)

    Column(
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.spacedBy(16.dp, Alignment.Top),
        modifier = Modifier
            .fillMaxSize()
            .padding(8.dp)
    ) {
        Text(
            "Wähle zwei Sounds in der gewünschten Reihenfolge aus",
            fontSize = Typography.Controller.title,
        )
        LazyColumn(
            verticalArrangement = Arrangement.spacedBy(8.dp),
            modifier = Modifier
                .fillMaxWidth()
                .weight(1f),
        ) {
            itemsIndexed(soundOptions) { index, option ->
                val isSelected = option.isSelected
                val shape = RoundedCornerShape(8.dp)
                Box(
                    modifier = Modifier
                        .fillMaxWidth()
                        .run {
                            if (index == 0) {
                                this.padding(top = 8.dp)
                            } else {
                                this
                            }
                        }
                ) {
                    Box(
                        contentAlignment = Alignment.Center,
                        modifier = Modifier
                            .fillMaxWidth()
                            .clip(shape)
                            .background(
                                if (isSelected)
                                    secondaryContainerLight.copy(alpha = 0.5f)
                                else
                                    Color.Transparent,
                            )
                            .drawWithCache {
                                onDrawBehind {
                                    if (isSelected && lockInTimeout != null) {
                                        drawRect(
                                            color = secondaryContainerLight,
                                            size = size.copy(
                                                width = size.width * lockInProgress.value,
                                            ),
                                        )
                                    }
                                }
                            }
                            .border(
                                width = 2.dp,
                                color = if (isSelected) onSecondaryContainerLight else Color.Transparent,
                                shape = shape,
                            ),
                    ) {
                        Button(
                            modifier = Modifier
                                .fillMaxWidth()
                                .clip(shape),
                            colors = if (isSelected) {
                                ButtonDefaults.buttonColors(
                                    containerColor = Color.Transparent,
                                    contentColor = onSecondaryContainerLight,
                                )
                            } else {
                                ButtonDefaults.buttonColors()
                            },
                            onClick = { onSoundSelected(index) },
                        ) {
                            Text(
                                option.text,
                                fontSize = Typography.Controller.body,
                            )
                        }
                    }
                    if (option.soundNumber != null) {
                        SoundNumberIndicator(
                            number = option.soundNumber,
                            modifier = Modifier
                                .align(Alignment.TopStart)
                                .offset(x = (-2).dp, y = (-2).dp)
                        )
                    }
                }
            }
        }
    }
}
